import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { OrderedMap, List } from 'immutable'
import { connect } from 'react-redux'
import Moment from 'moment'

import { TASK_TYPES } from '_utils/logEntryType'

import Icon from '_components/icon'
import CategoryTabBodyTimeframe from '_components/categoryTabs/categoryTabBodyTimeframe'
import { updateLastActivityAt } from '_modules/user/actions'
import { createTodayItem } from '_modules/today-items/actions'
import { createTomorrowItem } from '_modules/tomorrow-items/actions'
import { momentHumanize } from '_utils/helperFunction'
import TChart from '_components/tChart'

import styles from './styles.css'

const TIMEFRAMES = {
  Today: {
    date: Moment().format('YYYY-MM-DD'),
  },
  'This Week': {
    date: Moment()
      .subtract(7, 'days')
      .format('YYYY-MM-DD'),
  },
  'This Month': {
    date: Moment()
      .subtract(1, 'months')
      .format('YYYY-MM-DD'),
  },
  All: {
    date: Moment(0).format('YYYY-MM-DD'),
  },
}

const mapStateToProps = ({ log, engagement }) => ({
  log,
  engagements: engagement,
})

const mapDispatchToProps = {}

class Summary extends PureComponent {
  static propTypes = {
    log: ImmutableProptypes.map,
    engagements: ImmutableProptypes.map,
  }

  static defaultProps = {
    log: new Map(),
    engagements: new Map(),
  }

  state = {
    selectedTimeframe: 'Today',
  }

  getTableData = () => {
    const { log, engagements } = this.props
    const { selectedTimeframe } = this.state
    const timeframeDate = TIMEFRAMES[selectedTimeframe].date

    // filter todays logs
    const logsWithinTimeframe = log
      .toArray()
      .map(x => x.toJS())
      .filter(x => Moment(x.startedAt).isSameOrAfter(timeframeDate, 'day'))

    // filter todays logs
    const todaysEngagements = engagements
      .toArray()
      .map(x => x.toJS())
      .filter(entry => Moment(entry.createdAt).isSameOrAfter(timeframeDate, 'day'))

    // uniqueTasks - checks for unique task name
    const uniqueTasks = logsWithinTimeframe.reduce((uniqueTaskArr, item) => {
      if (!uniqueTaskArr.find(element => element === item.name)) {
        uniqueTaskArr.push(item.name)
      }
      return uniqueTaskArr
    }, []).length

    // totalTaskTime - loop through each occurences array of each logsWithinTimeframe entry
    const totalTaskTime = momentHumanize(
      Moment.duration(
        logsWithinTimeframe.reduce((total, item) => {
          const itemSubTotal =
            total +
            item.occurences.reduce((subTotal, occ) => {
              if (occ.endedAt === undefined) return subTotal
              const subTotalSeconds = subTotal + Moment(occ.endedAt).diff(occ.startedAt, 'seconds')
              return subTotalSeconds
            }, 0)
          return itemSubTotal
        }, 0),
        'seconds'
      )
    )

    // tasksCompleted - check if last occurence status is done
    const tasksCompleted = logsWithinTimeframe.reduce((total, item) => {
      if (
        item.occurences[item.occurences.length - 1] !== undefined &&
        item.occurences[item.occurences.length - 1].status === 2
      ) {
        return total + 1
      }
      return total
    }, 0)

    // taskInterruptions - check if last occurence status is switch
    const taskInterruptions = logsWithinTimeframe.reduce((total, item) => {
      if (
        item.occurences[item.occurences.length - 1] !== undefined &&
        item.occurences[item.occurences.length - 1].status === 3
      ) {
        return total + 1
      }
      return total
    }, 0)

    // mindfulBreaks - check if entry type is break
    const mindfulBreaks = logsWithinTimeframe.reduce((total, item) => {
      if (item.type === TASK_TYPES.break) {
        return total + 1
      }
      return total
    }, 0)

    const engagementLevelArray = todaysEngagements.map(item => item.engagementLevel).sort()

    // engagementLow
    const engagementLow = engagementLevelArray.length > 0 ? engagementLevelArray[0] : 0

    // engagementHigh
    const engagementHigh =
      engagementLevelArray.length > 0 ? engagementLevelArray[engagementLevelArray.length - 1] : 0

    // engagementAverage
    const engagementAverage =
      Math.round(
        (engagementLevelArray.reduce((total, item) => item + total, 0) /
          engagementLevelArray.length || 0) * 100
      ) / 100

    const tableData = {
      uniqueTasks,
      totalTaskTime,
      tasksCompleted,
      taskInterruptions,
      mindfulBreaks,
      engagementLow,
      engagementHigh,
      engagementAverage,
    }
    return OrderedMap(tableData)
  }

  handleTimeframeClick = click => {
    this.setState({
      selectedTimeframe: click.currentTarget.id,
    })
  }

  render() {
    const { selectedTimeframe } = this.state
    const tableData = this.getTableData()

    const keys = Object.keys(TIMEFRAMES)

    return (
      <CategoryTabBodyTimeframe
        selectedTimeframe={selectedTimeframe}
        timeframes={TIMEFRAMES}
        onChangeTimeframe={this.handleTimeframeClick}
      >
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <TChart data={tableData} />
        </div>
      </CategoryTabBodyTimeframe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary)



// WEBPACK FOOTER //
// ./src/views/log/summary/index.js